import { atom } from 'recoil'
import { Address, Company } from 'types'

export type BranchForm = {
  selectedCompany: Company
  companyName: string
  branchFormEditAddress: Address
}

export const branchFormState = atom({
  key: 'branchForm',
  default: {
    selectedCompany: {},
    companyName: '',
    branchFormEditAddress: {},
  } as BranchForm,
})
